export default "__VITE_ASSET__CsO2Ay0S__"